import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import {
  PDA1131_R01Dto,
  PDA1131_R01SearchParams,
  PDA1131_R01DetailDto,
  PDA1131_R01ScanResult,
  PDA1131_R01ShipRequest,
  PDA1131_R01ShipResult,
} from "../containers/PDA/PDA1131_R01/PDA1131_R01Dto";
import { getData, postData } from "../utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/PDA1131_R01`;

/** 출하지시 목록 (검색) */
export const searchShippingOrders = async (params?: PDA1131_R01SearchParams) => {
  return await getData<ResponseDto<PDA1131_R01Dto[]>>(`${baseUrl}/search`, { params });
};

/** 출하지시 목록 (새로고침) */
export const refetchShippingOrders = async (params?: PDA1131_R01SearchParams) => {
  return await getData<ResponseDto<PDA1131_R01Dto[]>>(`${baseUrl}/refetch`, { params });
};

/** 출하지시 상세 */
export const getShippingDetail = async (orderNo: string) => {
  return await getData<ResponseDto<PDA1131_R01DetailDto>>(`${baseUrl}/detail/${orderNo}`);
};

/** itemCd 스캔 (가용재고 반환) */
export const scanItem = async (
  scanValue: string,
  warehouseCd: string,
  logicCenter?: string
) => {
  return await getData<ResponseDto<PDA1131_R01ScanResult>>(
    `${baseUrl}/scan/${encodeURIComponent(scanValue)}`,
    { params: { warehouseCd, ...(logicCenter ? { logicCenter } : {}) } }
  );
};

/** 제품 출고 (주문 단위) */
export const shipProduct = async (request: PDA1131_R01ShipRequest) => {
  return await postData<PDA1131_R01ShipRequest, ResponseDto<PDA1131_R01ShipResult>>(
    `${baseUrl}/ship`,
    request
  );
};
